import React from 'react'
import { Button } from '../../../../../stories/Button/Button'
import { useNavigate } from 'react-router-dom'
import List, { VendorListPageFor } from '../vendorwise/List'
import SignalsTable from '../vendorwise/SignalsTable'

const VendorWise = () => {
    const navigate=useNavigate()
  return (
    <div className='signal-wise-report__vendor'>
        <div className="signal-wise-report__vendor--flex">
            <div className="signal-wise-report__vendor--left">
                <List pageType={VendorListPageFor.SIGNAL_WISE}/>
            </div>
            <div className="signal-wise-report__vendor--right">
                <SignalsTable pageType={VendorListPageFor.SIGNAL_WISE}/>
            </div>
        </div>
      <Button mode='back' onClick={()=>navigate(-1)}/>
    </div>
  )
}

export default VendorWise
